<template>
    <div class="lawsuit_info" v-loading="loading">
        <div class="box1">
            <div class="title_box">
                <div class="borders"></div>
                <div class="titles">
                    律师案例（{{total}}）
                </div>
            </div>
            <div class="list_box">
                <div class="lists" v-for="(item,index) in casse_list" :key="index" @click="handle_path(item)">
                    <div class="tages_titles">
                        <div class="tages">{{ item.pro.title }}</div>
                        <div class="titles">{{ item.title }}</div>
                    </div>
                    <!-- <div class="title_flex">
                        <div class="tetles">代理方：</div>
                        <div class="texts">被告</div>
                        <div class="bordes"></div>
                        <div class="tetles">结果：</div>
                        <div class="texts">少刑</div>
                    </div> -->
                    <div class="title_flex">
                        <div class="tetles">内容：</div>
                        <div class="texts">{{ item.content }}</div>
                     
                    </div>
                </div>
            </div>                
            
        </div>
       
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {
        
    },
    name: "homes",
    data() {
        return {
            loading:false,
            casse_list:[],
            total:0,
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_casse_list()
    },
    methods: {
        handle_path(item){
            this.$router.push({
                path:'/square_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_casse_list(){
            this.$api("caseSquare", {
                limit:6,
                lawyer_id:this.$route.query.id,
                status:99,
			}, "get").then((res) => {
                this.loading = false
                console.log('案例列表',res)
                if (res.code == 1) {
                    this.casse_list=res.data.data
                    res.data.data.forEach((e)=>{
                        if(e.third_json){
                            e.third_json=JSON.parse(e.third_json)
                        }
                    })
                    this.total=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.lawsuit_info{
    padding-top: 24px;
    .title_box{
        display: flex;
        // align-items: center;
        padding-top: 24px;
        padding-right: 32px;
        .borders{
            width: 4px;
            height: 22px;
            background: #377CFD;
            border-radius: 3px 3px 3px 3px;
        }
        .titles{
            flex: 1;
            // padding-left: 32px;
            margin-left: 28px;
            padding-bottom: 24px;
            border-bottom: 1px solid #D7D7D7;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            span{
                color: #377CFD;
            }
        }
    }
    .box1{
        min-height: 519px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .list_box{
            padding: 0 32px;
            .lists{
                padding: 24px 0;
                border-bottom: 1px solid #E5E5E5;
                .tages_titles{
                    display: flex;
                    align-items: center;
                    .tages{
                        // width: 62px;
                        padding: 0 10px;
                        height: 24px;
                        background: #FFFFFF;
                        border-radius: 2px 2px 2px 2px;
                        border: 1px solid #377CFD;

                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #377CFD;
                        text-align: center;
                        line-height: 24px;
                    }
                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        padding-left: 14px;
                    }
                }
                .title_flex{
                    display: flex;
                    align-items: center;
                    padding-top: 18px;
                    .tetles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                    }
                    .texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                    }
                    .bordes{
                        width: 0px;
                        height: 15px;
                        border: 1px solid #D7D7D7;
                        margin: 0 21px;
                    }

                }
            }
        }
    }
    
   
    
}

</style>